import './affirm';
import './afterpay';
import './klarna';